import { PropsWithChildren } from 'react'
import Styles from './Section.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'

import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Text } from 'blaze-ui/Text/Text'

interface SectionProps {
  title: string
  description?: string
  actions?: React.ReactNode
}

export const Section = ({ title, description, children, actions }: PropsWithChildren<SectionProps>) => {
  const { isMobile } = useResponsiveDesign()
  return (
    <div className={Styles.root}>
      <div className={Styles.headerContainer}>
        <div className={Styles.header}>
          <Heading level={isMobile ? 4 : 3}>{title}</Heading>
          {actions && <div>{actions}</div>}
        </div>
        {description && <Text variant="placeholder">{description}</Text>}
      </div>
      {children}
    </div>
  )
}
